<template>
  <StandardFlexBox
    direction="column"
    align_content="center"
    justify_content="center"
    height="270px"
    >
    <div
      :class="`mb-1 font-weight-medium`"
      v-if="!work_steps || work_steps.length === 0"
      >
      {{$t('Project.Workpackage.NoSteps.WorkStep')}}
    </div>
    <div
      :class="`mb-1  font-weight-medium`"
      v-if="!quality_steps || quality_steps.length === 0"
      >
      {{$t('Project.Workpackage.NoSteps.QualityStep')}}
    </div>
    <div
      :class="`mb-1  font-weight-medium`"
      v-if="!defect_steps || defect_steps.length === 0"
      >
      {{$t('Project.Workpackage.NoSteps.DefectStep')}}
    </div>
    <div
      :class="`mb-1  font-weight-medium`"
      v-if="!handover_steps || handover_steps.length === 0"
      >
      {{$t('Project.Workpackage.NoSteps.HandoverStep')}}
    </div>
    <div
      :class="`mb-1  font-weight-medium`"
      v-if="!design_steps || design_steps.length === 0"
      >
      {{$t('Project.Workpackage.NoSteps.DesignStep')}}
    </div>
    <div
      :class="`mb-1  font-weight-medium`"
      v-if="!logistic_steps || logistic_steps.length === 0"
      >
      {{$t('Project.Workpackage.NoSteps.LogisticStep')}}
    </div>
  </StandardFlexBox>
</template>
<script>
  import { WorkBenchWorkPackageInfoBoxMixin} from '@/mixins/WorkBenchWorkPackageInfoBox.mixin.js'
  export default {
    mixins: [
      WorkBenchWorkPackageInfoBoxMixin,
    ],
    data: () => ({
    }),
  }
</script>
<style>
  .class {

  }
</style>
